import { Box, Card, Divider, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import CreateEditIntegrationForm from './create-edit.form';
import GoBackButton from '../../components/go-back-button';

export default function CreateEditIntegration() {
    const { integrationid } = useParams();
    const editMode = !!integrationid;

    return (
        <>
            <Box mt={3} mb={1}>
                <GoBackButton />
                <Typography variant="h4" fontWeight={700} sx={{ color: 'primary.main', letterSpacing: 1, mt: 1 }}>
                    {editMode ? 'Editar Integração' : 'Nova Integração'}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                    {editMode ? 'Actualiza os dados da integração' : 'Configura uma nova API Key de integração externa'}
                </Typography>
                <Divider sx={{ mt: 2, borderColor: 'rgba(255,215,0,0.15)' }} />
            </Box>
            <Card sx={{ mt: 2, border: '1px solid rgba(255,215,0,0.15)' }}>
                <CreateEditIntegrationForm editMode={editMode} integrationId={integrationid} />
            </Card>
        </>
    );
}
